<div class="content-wrapper">
    <div class="content-body">
        <section id="dataToFilter">

            <!-- Leads header -->
            <div class="row align-items-center">
                <div class="col-6">
                    <h2 class="mt-2">Leads</h2>
                </div>
                <div class="col-6 text-right">
                    <button
                            class="btn btn-primary users-btn"
                            (click)="showSearch = !showSearch"
                    >
                        <i class="fa fa-search mr-2"></i> Search
                    </button>
                </div>
            </div>

            <!-- Search Form -->
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2" [formGroup]="searchForm" novalidate>
                        <div class="row">
                            <div class="col-12 col-md-4 mb-2 mb-md-0">
                                <input
                                        class="form-control"
                                        type="text"
                                        formControlName="email"
                                        placeholder="Email"
                                />
                            </div>
                            <div class="col-12 col-md-4 mb-2 mb-md-0">
                                <input
                                        class="form-control"
                                        type="number"
                                        formControlName="contact"
                                        placeholder="Contact"
                                />
                            </div>
                            <div class="col-12 col-md-4 text-center">
                                <button
                                        class="btn btn-primary btn-block btn-raised"
                                        (click)="search()"
                                        [disabled]="submitting"
                                >
                                    <i class="fa fa-search mr-1"></i> Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Leads Table -->
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="table-responsive">
                            <table class="table table-list text-center">
                                <thead>
                                <tr>
                                    <th><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6></th>
                                    <th
                                            *ngIf="user && (['SUPER_ADMIN'].indexOf(user['user_type']) !== -1)"
                                    >
                                        <h6 class="mt-1 mb-1 font-weight-bold">Counsellor</h6>
                                    </th>
                                    <th><h6 class="mt-1 mb-1 font-weight-bold">Full Name</h6></th>
                                    <th><h6 class="mt-1 mb-1 font-weight-bold">Contact</h6></th>
                                    <th class="d-none d-md-table-cell">
                                        <h6 class="mt-1 mb-1 font-weight-bold">Email</h6>
                                    </th>
                                    <th class="d-none d-md-table-cell">
                                        <h6 class="mt-1 mb-1 font-weight-bold">Message</h6>
                                    </th>
                                    <th><h6 class="mt-1 mb-1 font-weight-bold">Date & Time</h6></th>
                                </tr>
                                </thead>
                                <tbody
                                        *ngIf="
                    dataToFilter &&
                    dataToFilter.length > 0 &&
                    (!filteredData || filteredData.length === 0);
                    else filteredTable
                  "
                                >
                                <tr *ngFor="let admin of dataToFilter; let i = index">
                                    <td>
                                        <h6 class="mt-1">
                                            {{
                                                (pagination.page - 1) *
                                                (pagination.perpage ? pagination.perpage : 0) +
                                                i +
                                                1
                                            }}
                                            .
                                        </h6>
                                    </td>
                                    <td *ngIf="user && (['SUPER_ADMIN'].indexOf(user['user_type']) !== -1)">
                                        <h6 class="mt-1">{{ admin?.name }}</h6>
                                    </td>
                                    <td><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                    <td><h6 class="mt-1">{{ admin?.contact }}</h6></td>
                                    <td class="d-none d-md-table-cell">
                                        <h6 class="mt-1">{{ admin?.email }}</h6>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <h6 class="mt-1">{{ admin?.message }}</h6>
                                    </td>
                                    <td>
                                        <h6 class="mt-1">
                                            {{ admin?.created_at | date: 'yyyy-MM-dd HH:mm:ss' }}
                                        </h6>
                                    </td>
                                </tr>
                                </tbody>
                                <ng-template #filteredTable>
                                    <tbody
                                            *ngIf="filteredData && filteredData.length > 0; else noDataToShow"
                                    >
                                    <tr *ngFor="let admin of filteredData; let i = index">
                                        <td>
                                            <h6 class="mt-1">
                                                {{
                                                    (pagination.page - 1) * pagination.perpage + i + 1
                                                }}
                                                .
                                            </h6>
                                        </td>
                                        <td *ngIf="user && (['SUPER_ADMIN'].indexOf(user['user_type']) !== -1)">
                                            <h6 class="mt-1">{{ admin?.name }}</h6>
                                        </td>
                                        <td><h6 class="mt-1">{{ admin?.name }}</h6></td>
                                        <td><h6 class="mt-1">{{ admin?.contact }}</h6></td>
                                        <td class="d-none d-md-table-cell">
                                            <h6 class="mt-1">{{ admin?.email }}</h6>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <h6 class="mt-1">{{ admin?.message }}</h6>
                                        </td>
                                        <td>
                                            <h6 class="mt-1">
                                                {{ admin?.created_at | date: 'yyyy-MM-dd HH:mm:ss' }}
                                            </h6>
                                        </td>
                                    </tr>
                                    </tbody>
                                </ng-template>
                            </table>
                            <ng-template #noDataToShow>
                                <p class="text-center p-3">No data to show.</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pagination -->
            <div class="row pagination-table mt-3">
                <div class="col-12 d-flex justify-content-center">
                    <ngb-pagination
                            class="pagination-primary"
                            [collectionSize]="pagination.total"
                            [(page)]="pagination.page"
                            [boundaryLinks]="true"
                            [pageSize]="pagination.perpage"
                            [maxSize]="5"
                            (pageChange)="onPageChange($event)"
                    >
                        <ng-template ngbPaginationPrevious>
              <span
                      [data-feather]="'chevron-left'"
                      [size]="18"
                      [class]="'font-weight-bolder'"
              ></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
              <span
                      [data-feather]="'chevron-right'"
                      [size]="18"
                      [class]="'font-weight-bolder'"
              ></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </div>
        </section>
    </div>
</div>
